import { defineMessages } from 'react-intl';

// eslint-disable-next-line no-barrel-files/no-barrel-files
export { timeUnitAgoMessages } from './time-unit-ago-messages';

export const messages: {
	viewProfile: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	emailButtonLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	viewProfile: {
		id: 'search-page.social-signals.user-card.view-profile',
		defaultMessage: 'View profile',
		description: "Copy for button that will take the user to the displayed user's profile",
	},
	emailButtonLabel: {
		id: 'search-page.social-signals.user-card.email-button-label',
		defaultMessage: 'Copy email address',
		description:
			"Tooltip and a11y label to let the user know they can copy the user's email by interacting with the email icon button",
	},
});
